export default __webpack_public_path__ + "static/media/section-priority-ticket.32016266.png";